import {
  GroupElementScroll,
  Section,
  TitleAndDescription,
} from '@ferreri/prever-component-lib';

import { useCurrentListPlanVersions } from '../admin/plan-versions/plan-version.store';
import { useAllBenefits } from '../plan-benefit/plan-benefit.store';
import { PlanVersionsListCarousel } from './PlanVersionsListCarousel';
import { SkeletonCardPlanVersion } from './SkeletonCardPlanVersion';

const title = 'Compare os planos';
const description =
  'Com excelência e inovação, o Plano Angelus é referência em atendimento no Sul do Brasil. Escolha seu plano:';

export const PlanVersionsList = () => {
  const { data: benefits, isLoading: isLoadingBenefits } = useAllBenefits();
  const { data: plansVersions, isLoading: isLoadingPlanVersions } =
    useCurrentListPlanVersions();
  const isLoading = isLoadingBenefits || isLoadingPlanVersions;

  if (isLoading) {
    return (
      <Section>
        <TitleAndDescription title={title} description={description} />

        <GroupElementScroll>
          {Array.from({ length: 6 }).map((_, index) => (
            <SkeletonCardPlanVersion key={index} />
          ))}
        </GroupElementScroll>
      </Section>
    );
  }

  return (
    <Section>
      <TitleAndDescription title={title} description={description} />
      <PlanVersionsListCarousel
        planVersions={plansVersions}
        benefits={benefits}
      />
    </Section>
  );
};
